import approvalBox from './index.vue';

export default {
  install(Vue, options) {
    Vue.prototype.$commentBox = function(opts) {
      // 继承approvalBox组件
      const CommentConstructor = Vue.extend(approvalBox);
      // 创建一个新元素
      const commentWrap = document.createElement('div');
      commentWrap.className = 'comment-box-wrap';
      // 实例化approvalBox组件，并将组件挂在到新创建的approval-box-wrap元素上
      const approvalInstace = new CommentConstructor({
        el: commentWrap
      });
      // 或者使用 approvalInstace.$mount(commentWrap)挂载
      document.body.appendChild(approvalInstace.$el);
      // 显示组件内容
      if (opts) {
        approvalInstace.callBack = opts.callBack;
        approvalInstace.placeholder = opts.placeholder;
        approvalInstace.title = opts.title;
      }
      approvalInstace.commentBoxVisiable = true;
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/commentBox/index.js